import { Attrs, MinzeElement, Reactive } from 'minze'

export interface LvcCheckIcon {
  dataSize?: number
  iconSize?: number
}

export class LvcCheckIcon extends MinzeElement {
  attrs: Attrs = [['data-size', 28]]
  reactive: Reactive = [['iconSize', this.dataSize || 28]]

  static observedAttributes = ['data-size']

  html = () => `
    <svg
      width="${this.dataSize || '28'}"
      height="${this.dataSize || '28'}"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.8 7C19.4769 11.2457 15.1812 15.9772 11.1082 20.4946C10.8545 20.776 10.4226 20.8043 10.1344 20.5582C7.8324 18.5917 6.15621 17.091 4.19995 14.6147" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
